<mat-card *ngIf="data">
  <mat-card-content>
    <h2 class="mb-0 info-title">{{data.title}}</h2>

    <div class="carousel-with-navigation">
      <swiper-container
        #carousel
        space-between="16"
        pagination="true"
        pagination-clickable="true"
        [breakpoints]="breakpoints"
        class="carousel"
      >
        <swiper-slide *ngFor="let event of data.events">
          <app-portal-event-card [event]="event" />
        </swiper-slide>
      </swiper-container>

      <div class="d-phone-none">
        <button *ngIf="data.events.length > 2" class="button-prev" [ngClass]="{ locked: lockPrev }" (click)="prevSlide()">
          <mat-icon [svgIcon]="'prev-2'" class="square-icon button-icon"></mat-icon>
        </button>
        <button *ngIf="data.events.length > 2" class="button-next" [ngClass]="{ locked: lockNext }" (click)="nextSlide()">
          <mat-icon [svgIcon]="'next-2'" class="square-icon button-icon"></mat-icon>
        </button>
      </div>
    </div>

    <div *ngIf="data.buttonUrl" class="text-center mt-1">
      <app-portal-button 
        [target]="data.buttonTarget"
        [link]="data.buttonUrl"
        classes="w-phone-100"
        color="primary" 
        [title]="data.buttonText"/>
    </div>
  </mat-card-content>
</mat-card>
